module.exports = __webpack_public_path__ + "img/成都办公室1.f3dc23a7.jpg";